import { render, staticRenderFns } from "./AdminAssignCourier.vue?vue&type=template&id=45fe478c&scoped=true"
import script from "./AdminAssignCourier.vue?vue&type=script&lang=js"
export * from "./AdminAssignCourier.vue?vue&type=script&lang=js"
import style0 from "./AdminAssignCourier.vue?vue&type=style&index=0&id=45fe478c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe478c",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
